var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDonor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_801_22356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4606 14.2609C18.2704 14.2609 21.3588 11.1591 21.3588 7.33283C21.3588 3.50657 18.2704 0.404785 14.4606 0.404785C10.6507 0.404785 7.56226 3.50657 7.56226 7.33283C7.56226 11.1591 10.6507 14.2609 14.4606 14.2609Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.205322 29.3114C0.205322 21.4107 6.5769 14.9946 14.4607 14.9946C22.3444 14.9946 28.716 21.3937 28.716 29.3114H0.205322Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2789 18.6128C15.5483 18.6128 14.8856 18.9541 14.4439 19.4831C14.0021 18.9541 13.3564 18.6128 12.6088 18.6128C11.2836 18.6128 10.2131 19.6878 10.2131 21.0188C10.2131 21.599 10.434 22.128 10.7738 22.5546L14.4099 26.5476L17.842 22.7935C18.3348 22.3498 18.6406 21.7185 18.6406 21.0188C18.6746 19.6878 17.6042 18.6128 16.2789 18.6128Z",
    fill: "#C4D1E3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_801_22356"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.4937,
    height: 28.9067,
    fill: "white",
    transform: "translate(0.205322 0.404785)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDonor);
export default __webpack_public_path__ + "static/media/icon-donor.4c70d8d8c4d0327f9a55b3302c897257.svg";
export { ForwardRef as ReactComponent };